import React from 'react';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import { ModalComponent } from '../../../ui/modals/Modal/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import styles from './index.module.scss.js';

const UnavailableModal = ({
  isOpen,
  onClose,
  blockPageScroll,
  children,
  afterOpenModal = () => {
  },
  onAfterClose = () => {
  }
}) => {
  const { isMobile, windowSize } = useWindowSize();
  return /* @__PURE__ */ React.createElement(
    ModalComponent.Modal,
    {
      modalIsOpen: isOpen,
      bottom: true,
      closeModal: () => onClose(),
      hideCloseButton: true,
      blockPageScroll,
      afterOpenModal,
      onAfterClose,
      configuration: isMobile ? {
        overlay: {
          display: "flex",
          justifyContent: "center",
          alignItems: "normal",
          width: "100vw",
          height: `${window.innerHeight}px`,
          overflowY: "hidden",
          padding: "0"
        },
        content: {
          position: "unset",
          padding: "0",
          height: "auto",
          maxHeight: "98%",
          minHeight: "auto",
          maxWidth: "100%",
          width: "100%",
          overflow: "hidden",
          // transform: "unset !important",
          margin: "auto 0 0 0",
          borderRadius: "12px 12px 0 0"
        },
        childrenWrapper: {
          borderRadius: 0
        }
      } : {
        content: {
          height: "fit-content",
          maxHeight: "99%",
          width: "470px",
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden"
        }
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles.box,
        style: {
          "--height": `${windowSize.height / 100 * 90 + 20}px`
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.pulldown, "data-modal-header-line": true }, /* @__PURE__ */ React.createElement("div", null)),
      children
    )
  );
};
UnavailableModal.displayName = "UnavailableModal";

export { UnavailableModal };
//# sourceMappingURL=index.js.map
